import { DataHoraDTO } from '../../dtos/data-hora-dto';
import { PacienteDTO } from '../../dtos/paciente-dto';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { Filial } from '../../filial/filial';
import { Paciente } from '../../paciente/paciente';
import { PlanoSaude } from '../../plano-saude/plano-saude';
import { Procedimento } from '../../procedimento/procedimento';
import { FechamentoMarcacao } from '../fechamento-marcacao';
import { MotivoCancelamentoMarcacao } from '../motivo-cancelamento-marcacao';
import { MarcacaoPK } from './pks/marcacao-pk';

export class Marcacao {
  public static readonly STATUS_AGENDADO: string = 'A';

  public static readonly STATUS_FINALIZADO: string = 'F';

  public static readonly STATUS_CANCELADO: string = 'C';

  pk: MarcacaoPK = new MarcacaoPK();

  dataCriacao: Date = new Date();

  horaAtendimento: string = '';

  status: string = '';

  filial: Filial = new Filial();

  paciente: Paciente = new Paciente();

  pacienteSelecionado: PacienteDTO = new PacienteDTO();

  planoSaude: PlanoSaude = new PlanoSaude();

  procedimento: Procedimento = new Procedimento();

  idMedico: number = 0;

  nomeMedico: string = '';

  cobrarProcedimento: boolean = false;

  listaDatasDisponiveis: Array<DataHoraDTO> = [];

  listaDatasNaoDisponiveis: Array<Date> = [];

  melhorData: Date = new Date();

  melhorHora: string = '';

  melhorHoraFormatada: string = '';

  dataInicioMarcacao: Date = new Date();

  dataFimMarcacao: Date = new Date();

  marcacaoSelecionada: boolean = false;

  loginUserMarcacao: string | null = null;

  portadorNecessidade: boolean = false;

  motivoCancelamentoMarcacao: MotivoCancelamentoMarcacao =
    new MotivoCancelamentoMarcacao();

  fechamentoMarcacao: FechamentoMarcacao = new FechamentoMarcacao();

  comprovanteSMSEnviado: boolean = false;

  comprovanteSMSEnviadoAutomaticamente: boolean = false;

  tipoMarcacao: TipoMarcacaoEnum = TipoMarcacaoEnum.TIPO_MARCACAO_EXAME;

  qtdDiasAgendaMedico: number = 0;

  constructor() {}
}
